<template>
    <div
        :id="id"
        :class="{
            filled: filled,
            focused: focused,
            disabled: disabled,
            error: error,
            'no-label': !label,
        }"
        class="tl-input-text tl-input-email"
    >
        <div
            v-if="title"
            class="tl-title"
        >
            {{ title }}
        </div>
        <div class="tl-input-wrapper">
            <input
                ref="input"
                v-model="modelState"
                type="email"
                :disabled="disabled"
                :maxlength="maxlength"
                @focus="focused = true"
                @blur="focused = false"
                @keyup="handleKey"
            />
            <div
                v-if="label"
                class="tl-label"
            >
                <div>{{ label }}</div>
            </div>
        </div>
        <ErrorText
            v-if="error"
            :error="error"
        />
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue'
import useTools from 'widget-components/utilities/tools'
import ErrorText from 'widget-components/components/ErrorText/ErrorText.vue'

const { wait } = useTools()

defineOptions({ inheritAttrs: false })

const props = defineProps({
    id: String,
    modelValue: String,
    disabled: Boolean,
    focus: Boolean,
    maxlength: [Number, String],
    error: {
        type: [String, Boolean],
        default: undefined,
    },
    initialValue: String,
    label: String,
    title: String,
    blockPath: Array,
})

const emit = defineEmits(['update:modelValue', 'submit'])

const input = ref(null)

const modelState = ref(props.modelValue)
const modelValue = computed(() => props.modelValue)

const filled = computed(() => !!modelState.value)
const focused = ref(false)
const label = computed(() => props.label)

onMounted(async () => {
    if (props.focus) {
        await wait(800)
        input.value?.focus()
    }

    if (props.initialValue) {
        modelState.value = props.initialValue
    }
})

watch(modelState, (val) => {
    emit('update:modelValue', val)
})

watch(modelValue, (val) => {
    if (val !== modelState.value) modelState.value = val
})

const handleKey = (event) => {
    const code = event.keyCode

    // ENTER
    if (code === 13 || event.key === 'enter') {
        emit('submit')
    }
}
</script>

<style scoped lang="sass">
@import '../InputText/InputText.sass'
</style>
